import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GS1ButtonDirective } from '@gs1france/gs1-components-library';

export interface DialogData {
  iscancel?: boolean;
  dialogTitle: string;
  dialogText: string;
  dialogActions: string;
  dialogPrecision: string;
  dialogButtonConfirm: string;
  dialogButtonCancel: string;
  codeType?: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],

  imports: [TranslateModule, MatDialogModule, GS1ButtonDirective]
})
export class DialogComponent {
  public dialogRef = inject(MatDialogRef<DialogComponent>);
  public data = inject<DialogData>(MAT_DIALOG_DATA);

  onNoClick(): void {
    this.dialogRef.close();
  }
}
